import { type FunctionComponent } from "react";

import ceIcon from "images/Common/CEicon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedClearEstimates: FunctionComponent<IBTIconProps> = (baseProps) => {
    return <img alt="" src={ceIcon} style={baseProps.style} className={baseProps.className} />;
};
